import { close } from "../../domain/modal/modalModel";
import { UpdateModalOpenStore, updateModalUseCase } from "./updateOpenModalUseCase";

const closeModalUseCase = (store: UpdateModalOpenStore) => {
    return updateModalUseCase(store, close)
}

export { closeModalUseCase }